import { dashboardApi } from '@/api';
import { OptimisationBase } from '@/optimizer';

interface CreateCampaignArgs {
    projectId: string;
    dashboardId: string;
    name: string;
    startDate: string | undefined;
    endDate: string | undefined;
    budget: number | undefined;
    optimizationBase?: OptimisationBase;
    rules: {
        channel: string;
        type: string;
        value: number | string;
    }[];
    disabledChannels?: string[];
    sourceCampaignId?: string;
    activeDaysPerMedium?: Record<string, number>;
}

export const createCampaign = async ({
    projectId,
    dashboardId,
    name,
    startDate = '',
    endDate = '',
    budget = 0,
    optimizationBase,
    rules = [],
    disabledChannels = [],
    sourceCampaignId,
    activeDaysPerMedium,
}: CreateCampaignArgs) => {
    await dashboardApi({
        method: 'POST',
        url: `/customer-campaign/project/${projectId}/campaign`,
        data: {
            name,
            startDate,
            endDate,
            budget,
            optimizationBase,
            rules,
            disabledChannels,
            dashboardId,
            sourceCampaignId,
            activeDaysPerMedium,
        },
    });
};
